import { useMutation, useQueryClient } from "react-query";
import http from "infra/http";
import { showErrorAxios } from "infra/helpers/alerta";

function useCancelarCobranca(invalidateQuery = "/v1/conta") {
  const queryClient = useQueryClient();
  return useMutation(
    `post/v1/conta/cancelar-cobranca`,
    (ids: string[]) => http.post(`/v1/conta/cancelar-cobranca`, { ids }),
    {
      retry: false,
      onError: (e) => {
        showErrorAxios(e);
      },
      onSuccess: () => {
        if (invalidateQuery) {
          queryClient.invalidateQueries({
            predicate: ({ queryKey }) =>
              typeof queryKey === "string" && queryKey.startsWith(invalidateQuery),
          });
        }
      },
    }
  );
}

export default useCancelarCobranca;
